import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { Box, ButtonBase, Stack, Typography } from '@mui/material';
import React from 'react';
import { ChooseNextExercise } from '../../mockLessonContent';
import { BLUE, cardSx, INTER, NAVY, POPPINS, SLATE, SURFACE_SOFT } from '../../studentStyles';
import ExerciseLabel from './ExerciseLabel';

interface ChooseNextExerciseCardProps {
    exercise: ChooseNextExercise;
    onReady: () => void;
}

// "Select next dialog" — the student picks where the lesson goes next. In the
// mockup the pick is cosmetic; the player carries on to the finish screen.
export default function ChooseNextExerciseCard({ exercise, onReady }: ChooseNextExerciseCardProps) {
    const [pickedIndex, setPickedIndex] = React.useState<number | null>(null);

    const handlePick = (index: number) => {
        setPickedIndex(index);
        onReady();
    };

    return (
        <Box>
            <ExerciseLabel>WHAT&apos;S NEXT</ExerciseLabel>
            <Typography sx={{ fontFamily: POPPINS, fontWeight: 600, fontSize: 20, color: NAVY, lineHeight: 1.35 }}>
                {exercise.prompt}
            </Typography>
            <Stack spacing={1.25} sx={{ mt: 2.5 }}>
                {exercise.options.map((option, index) => {
                    const isPicked = pickedIndex === index;
                    return (
                        <ButtonBase
                            key={option.title}
                            onClick={() => handlePick(index)}
                            sx={{
                                ...cardSx,
                                width: '100%', p: 2, display: 'flex', alignItems: 'center', gap: 1.5, textAlign: 'left',
                                border: `2px solid ${isPicked ? BLUE : 'transparent'}`,
                                backgroundColor: isPicked ? `${BLUE}0A` : '#fff',
                                transition: 'background-color 150ms ease, border-color 150ms ease',
                            }}
                        >
                            <Box sx={{
                                width: 44, height: 44, borderRadius: '14px', flexShrink: 0,
                                display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: SURFACE_SOFT,
                            }}>
                                <Typography sx={{ fontSize: 22, lineHeight: 1 }}>{option.emoji}</Typography>
                            </Box>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Typography sx={{ fontFamily: POPPINS, fontWeight: 600, fontSize: 15, color: NAVY, lineHeight: 1.3 }}>
                                    {option.title}
                                </Typography>
                                <Typography sx={{ fontFamily: INTER, fontSize: 12, color: SLATE, mt: 0.25 }}>
                                    {option.detail}
                                </Typography>
                            </Box>
                            <ChevronRightRoundedIcon sx={{ color: isPicked ? BLUE : SLATE }} />
                        </ButtonBase>
                    );
                })}
            </Stack>
        </Box>
    );
}
